import { apiSlice as api } from '../../../../apiSlice';
export const addTagTypes = ['DataTypes'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      dataTypesGetCollection: build.query<
        DataTypesGetCollectionApiResponse,
        DataTypesGetCollectionApiArg
      >({
        query: () => ({ url: `/DataTypes` }),
        providesTags: ['DataTypes'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as recalcOpenApi };
export type DataTypesGetCollectionApiResponse =
  /** status 200 user entities response */ ReadDataTypeDto[];
export type DataTypesGetCollectionApiArg = void;
export type ReadDataTypeDto = {
  Key: string;
  Aggregations?: ('Raw' | 'Minutes5' | 'Hour' | 'Day')[];
  ProduceableSensors?: string[];
  Base?: string;
  AccumulationType:
    | 'Accumulated'
    | 'Consumption'
    | 'ConsumptionPoint'
    | 'Point';
};
export type ErrorResult = {
  Code: string;
  Message: string;
};
export type BadRequestError = {
  Code: string;
  Message: string;
};
export type PropertyValueError = {
  Property: string;
  Code: string;
  Message: string;
};
export type ArrayProperty = {
  Property?: ArrayProperty;
  Name: string;
  Index?: number;
};
export type ArrayPropertyValueError = {
  Property: ArrayProperty;
  Code: string;
  Message: string;
};
export type ErrorDetailsResult2 = ErrorResult & {
  BadRequestErrors?: BadRequestError[];
  PropertyValueErrors?: PropertyValueError[];
  ArrayPropertyValueErrors?: ArrayPropertyValueError[];
};
export type ErrorDetailsResult = ErrorDetailsResult2;
export type ErrorResult2 = ErrorResult;
export type ErrorResult3 = ErrorResult;
export const {
  useDataTypesGetCollectionQuery,
  useLazyDataTypesGetCollectionQuery,
} = injectedRtkApi;
